export const DoctorUtil = {
  getMedicalProduct(person) {
    if (!person.products || !person.products.products) return false

    let product = false
    Object.keys(person.products.products).forEach(productId => {
      const _product = person.products.products[productId]
      if (_product.selected && _product.doctor) {
        product = Object.assign({}, _product, { id: productId })
      }
    })

    return product
  },

  /**
   * Returns doctors that could be transferred from another person.
   * Adults can only copy from other adults, children only from children.
   * @param persons
   * @param currentPersonId
   * @returns {*}
   */
  getTransferableDoctorFromOtherPerson(persons, currentPersonId) {
    const adultAge = 18
    const currentPerson = persons.find(p => p.personId === currentPersonId)

    const haveSameAgeGroup = (person, otherPerson) => {
      if (person.personId === otherPerson.personId) return false
      if (person.age >= adultAge && otherPerson.age >= adultAge) return true
      if (person.age < adultAge && otherPerson.age < adultAge) return true
      return false
    }

    return (
      persons
        // can only transfer doctor within same age group
        .filter(p => haveSameAgeGroup(p, currentPerson))
        .filter(person => DoctorUtil.getMedicalProduct(person))
        .map(person => {
          const sourceProduct = DoctorUtil.getMedicalProduct(person)
          return {
            productId: sourceProduct.id,
            source: person.personId,
            doctor: sourceProduct.doctor,
          }
        })
    )
  },
}
